export const setting= {
  name: "Miviajeseguro",
  production: true,
  c_domain: '.miviajeseguro.com',
  authApiUrl: 'https://fusionpax-api.fusionpax.com/api/',
  appUrl: 'https://login.miviajeseguro.com',
  appBookingBackoffice: 'https://booking-bo.miviajeseguro.com/',
  appBookingUrl: 'https://booking-app.miviajeseguro.com/',
  apiBookingUrl: 'https://booking-api.miviajeseguro.com/api/v1/',
  apiOctopusUrl: 'https://octopus-api.fusionpax.com/api',
  routeUploadFile: 'https://fusionpax-api.fusionpax.com/storage/',  // Temporal
  octopusUrl: 'https://octopus-api.fusionpax.com/api',
  apiStorageBooking: 'https://booking-api.miviajeseguro.com/storage/',
  appAbacoUrl: 'https://abaco-app.miviajeseguro.com/',  /// abaco
  appZocoUrl: 'https://zoco-app.miviajeseguro.com/',   /// zoco
  booking_api_user: "PRODAUTH1644",
  booking_api_key: "e9a65b94ce026c5ca1c2ec0bf65a085cbf992c55d5cd16ad63eabb7f5ac1b258",
  ApiUser : "MVSO243578",
  ApiKey  : "7642M120N87VS23",
  fusionPaxTest: 'https://fusionpax-api-test.fusionpax.com/api/chat/messages',
  // Cloudflare Turnstile - captcha en login, resetPass, signup/agencies y signup/providers.
  // Switch temporal: dejar en false hasta tener la site key real Y que el backend
  // valide turnstileToken contra siteverify. En false, el widget no se muestra y
  // ning n form exige token (no bloquea login/registro mientras tanto).
  turnstileEnabled: true,
  turnstileSiteKey: '0x4AAAAAAEkPJD7RgyknidbB',
  twoFactorEnabled: true,
  heroVariant: 'animated' as 'classic' | 'animated',
  app_names: {
        booking_backoffice: 'backoffice',
        zoco: 'zoco',
        booking: 'booking',
        abaco: 'abaco',
        chat: 'chat',
        octopus: 'octopus'
  },
  ActivatedGuard: true,
  key_local_storage: 'amE89mVkKihT^c%C&G5!wf2*4MX*dkkb6ZtbrsJAnASJmA9d5ddWjaCKLea$SWsvQB^L^q$M!qUm^LRK',
  legacyAuthCookie: true,
}
